var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M460-100v-58.46q-125-11.69-206.42-93.12Q172.15-333 160.46-458H102v-40h58.46q11.69-125 93.12-206.42Q335-785.85 460-797.54V-856h40v58.46q125 11.69 206.42 93.12Q787.85-623 799.54-498H858v40h-58.46q-11.69 125-93.12 206.42Q625-170.15 500-158.46V-100h-40Zm20-98q116 0 198-82t82-198q0-116-82-198t-198-82q-116 0-198 82t-82 198q0 116 82 198t198 82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportLocation);
export default __webpack_public_path__ + "static/media/transport-location.ee3da7461e05eac2889c9025ac743749.svg";
export { ForwardRef as ReactComponent };